const React = require('react');
const isNode = (typeof process !== 'undefined');
const Input = require('./../../FormComponents/Input');

class Other extends React.Component {
    getValues() {
        return {
            comment: this.comment.value,
        }
    }
    render() {
        const {hideHeaders, color} = this.props;

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Andre henvendelser</h2>}
            <div className="forms__formElement">
                <label className="form-label">Beskjed</label>
                <textarea placeholder="Beskjed" ref={(comment) => this.comment = comment}/>
            </div>
        </div>
        )
    }
}

module.exports = Other;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/Other/index.jsx